import React  from "react";
import { FaSearch } from "react-icons/fa";
import "./InputSearch.css";

class InputSearch extends React.Component {

    constructor(props){
        super(props);
        this.state = { searchText: props.searchText || "" }
    };

    handleKeyDown = (e) => {
		if (e.keyCode === 13 || e.keyCode === 10) {
			this.props.handleSearch(this.state.searchText);
		}
	};

    handleOnChange = (e) => {
        this.setState({searchText : e.target.value});
    };

    clear = () => {
        this.setState({ searchText: '' });
        this.props.handleClear();
    };

    render(){
        const { handleSearch } = this.props;
        const { searchText } = this.state;
        return (
            <div className="_searchBlock">
                <input
                    id="_search"
                    className="_searchInput"
                    placeholder="Search"
                    onKeyDown={this.handleKeyDown}
                    onChange={this.handleOnChange}
                    value={searchText}
                />
                { searchText && <span className="_clearIcon" onClick={this.clear}> x </span> }
                <FaSearch className="_searchBtn" onClick={() => handleSearch(searchText)} />
            </div>
        )
    }
}

export default InputSearch;


// WEBPACK FOOTER //
// ./src/common/components/Search/InputSearch.jsx